import moment from 'moment'

const slotIsPast = (slot) => moment(slot.startTime).isBefore()
export default slotIsPast